import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSunset: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"sunset"} maskId="square-filled-radius-0-stroke-1-IconSunset"><path fillRule="evenodd" clipRule="evenodd" d="M6 20H18V21H6V20Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M1 16H23V17H1V16Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M3 13V12.5C3 7.28061 7.0029 3 12 3C16.9971 3 21 7.28061 21 12.5V13C18.5693 13 5.43068 13 3 13Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconSunset;
